var map = {
	"./en.png": "a35e",
	"./en_au.png": "a720",
	"./en_ca.png": "5234",
	"./en_id.png": "be94",
	"./en_mm.png": "b3ba",
	"./en_my.png": "6182",
	"./en_nz.png": "d597",
	"./en_sg.png": "585e",
	"./en_st.png": "c42a",
	"./en_th.png": "43e5",
	"./en_uk.png": "23a9",
	"./en_vn.png": "b903",
	"./es.png": "982a",
	"./flags/ico_australia.png": "5476",
	"./flags/ico_canada.png": "a765",
	"./flags/ico_indonesia.png": "d65e",
	"./flags/ico_malaysia.png": "e766",
	"./flags/ico_mexico.png": "b594",
	"./flags/ico_myanmar.png": "4a47",
	"./flags/ico_newzealand.png": "7876",
	"./flags/ico_scotland.png": "e28b",
	"./flags/ico_singapore.png": "0fe6",
	"./flags/ico_thailand.png": "e551",
	"./flags/ico_uk.png": "fe14",
	"./flags/ico_usa.png": "d154",
	"./flags/ico_vietnam.png": "da0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39a0";